import http from 'src/helper/http'

/**
 * @desc return the client params
 * @returns Promise
 */
async function apiGetUploadParams() {
  let data = await http.post('/web/oss/upload')
  return data
}

const randomString = function (n) { // 生成n位长度的字符串
  var str = "abcdefghijklmnopqrstuvwxyz0123456789"; // 可以作为常量放到random外面
  var result = "";
  for (var i = 0; i < n; i++) {
    result += str[parseInt(Math.random() * str.length)];
  }
  return result;
}

const RANDOMNUM = 10
const TID = Date.now()

/**
 * @desc 上传图片
 * @param {*} files 文件
 * @param {*} suffix 后缀(png/jpg)
 * @param {*} dir 路径(web/xxx.png)
 * @returns 
 */
const uploadImg = async (files, suffix, dir) => {
  try {
    const DIR = dir ? dir : "web"
    const SUFFIX = suffix ? suffix : "png"
    const res = await apiGetUploadParams()
    const client = new OSS({
      // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
      region: 'oss-cn-hangzhou',
      secure: true,
      // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
      accessKeyId: res && res.res && res.res.AccessKeyId,
      accessKeySecret: res && res.res && res.res.AccessKeySecret,
      // 从STS服务获取的安全令牌（SecurityToken）。
      stsToken: res && res.res && res.res.SecurityToken,
      // 填写Bucket名称。
      bucket: 'upload-hz-vo',
    })
    const result = await client.put(
      `${DIR}/${randomString(RANDOMNUM) + TID}.${SUFFIX}`,
      files,
    );
    console.log(result, 'result')
    return result
  } catch (error) {
    console.log(error)
  }
}

export default uploadImg


// WEBPACK FOOTER //
// src/tools/uploadImage.js